<template>
  <div>
    <v-card outlined tile elevation="0" class="rounded-lg ma-4">
      <v-sheet :class="showCard ? '' : 'rounded-lg'" color="primary">
        <v-card-title class="pa-2 card-title-height">
          <v-btn icon elevation="0" class="" @click="showCard = !showCard">
            <v-icon color="white">
              {{
                showCard ? "mdi-chevron-up" : "mdi-chevron-down"
              }}
            </v-icon>
          </v-btn>
          <div class="text-body-1 ml-2 white--text">
            Contexte(s)
          </div>
          <v-spacer />
          <v-select
            v-if="!disabled"
            ref="selectContext"
            outlined
            :items="allAvailableContexts"
            hide-details
            dense
            flat
            label="Add context"
            solo
            style="max-width: 200px"
            @input="addContext"
          />
        </v-card-title>
      </v-sheet>
      <v-expand-transition>
        <div v-show="showCard">
          <v-skeleton-loader
            v-if="loading"
            class="mx-auto"
            type="table: table-thead, table-tbody"
          />
          <template v-for="([key, values], index) in Object.entries(iresaIds)" v-else>
            <v-list :key="index">
              <v-list-item v-if="['alpha', 'pegase'].includes(key)" :key="key" class="d-flex justify-space-evenly flex-wrap my-2">
                <v-chip
                  v-for="v in values"
                  :key="v.iresaId"
                  :dark="v.activeId && !v.isDeactivated"
                  :color="v.isDeactivated ? 'grey darken-2' : getColor(key, v.activeId)"
                  :class="['mr-1 my-1', { 'deactivated-chip': v.isDeactivated }]"
                >
                  {{ v.label }}
                </v-chip>
              </v-list-item>

              <v-list-item v-else :key="key" class="d-flex justify-space-evenly flex-wrap my-2">
                <v-chip
                  v-for="v in values"
                  :key="v.iresaId"
                  :dark="v.activeId && !v.isDeactivated"
                  :color="v.isDeactivated ? 'grey darken-2' : getColor(key, v.activeId)"
                  :class="['mr-1 my-1', { 'deactivated-chip': v.isDeactivated }]"
                  @click="openDialog(v)"
                >
                  {{ v.label }}
                </v-chip>
              </v-list-item>
              <v-divider class="mx-5 my-2" />
            </v-list>
          </template>
        </div>
      </v-expand-transition>
    </v-card>

    <Modal v-if="showContextModal" max-width="850" :show.sync="showContextModal" :close="closeContextModal">
      <template #title>
        <div class="col-12 d-flex justify-center m-0 p-0">
          <span class="title"> {{ modalContext.label }} </span>
        </div>
      </template>
      <template #text>
        <v-card-text class="text-center">
          <span class="subtitle-1"> Vous souhaitez apporter des modifications en   <strong>{{ modalContext.iresaId }}</strong> ? </span>
        </v-card-text>
      </template>
      <template #actions>
        <div class="d-flex col-12 justify-space-between">
          <div class="col-5 ma-0 pa-0 d-flex justify-space-between">
            <v-btn width="200" color="secondary" @click="openConfirmationDialog()">
              Supprimer iresa id
            </v-btn>
            <v-btn width="120" color="primary" :disabled="modalContext.activeId || modalContext.isDeactivated" @click="setActiveCode()">
              Actif
            </v-btn>
          </div>
          <div class="col-4 ma-0 pa-0 d-flex justify-space-between">
            <v-btn width="130" color="secondary" @click="goContext()">
              Aller à iresa
            </v-btn>
            <v-btn width="120" color="secondary" @click="closeContextModal()">
              Fermer
            </v-btn>
          </div>
        </div>
      </template>
    </Modal>
    <Modal v-if="showConfirmDeleteContext" :show.sync="showConfirmDeleteContext" max-width="340" :close="closeConfirmDeleteContext">
      <template #title>
        <span class="title">Confirmer la Suppression </span>
      </template>
      <template #text>
        <h2 class="bold">
          Voulez-vous vraiment supprimer ce contexte lié?
        </h2>
      </template>
      <v-spacer />
      <template #actions>
        <v-col>
          <v-btn width="292" class="mr- mb-2" color="primary" @click="removeIresaIdFromCustomer()">
            <span class="ml-2 d-none d-sm-inline-block">Oui</span>
          </v-btn>
          <v-btn width="292" class="mr-2" color="secondary" @click="closeConfirmDeleteContext">
            <span class="ml-2 d-none d-sm-inline-block">Non</span>
          </v-btn>
        </v-col>
      </template>
    </Modal>
    <Modal v-if="dialogCreatAddContext" :show.sync="dialogCreatAddContext" max-width="500" :close="closeDialogCreatAddContext">
      <template #title>
        <div class="col-12 d-flex justify-center m-0 p-0">
          <v-card-title>
            Ajouter / Créer un contexte
          </v-card-title>
        </div>
      </template>
      <template #text>
        <v-card-text class="text-center">
          <span class="subtitle-1"> Voulez-vous ajouter ou créer un identifiant iresa dans le contexte  {{ selectContext }}? </span>
        </v-card-text>
      </template>
      <template #actions>
        <v-card-actions class="d-flex col-12 justify-center">
          <v-btn
            color="secondary"
            elevation="0"
            class="mr-2 pl-3 pr-5"
            large
            @click="addIresaIdToContext()"
          >
            <v-icon class="pr-1">mdi-plus</v-icon>
            Ajouter
          </v-btn>
          <v-btn
            :disabled="alreadyHasSelectedContext"
            color="secondary"
            elevation="0"
            class="mr-2 pl-3 pr-5"
            large
            @click="createNewIresaId()"
          >
            <v-icon class="pr-1">mdi-plus</v-icon>
            Créer
          </v-btn>
          <v-btn
            color="secondary"
            elevation="0"
            class="mr-2 pl-3 pr-5"
            large
            @click="closeDialogCreatAddContext()"
          >
            <v-icon class="pr-1">mdi-minus</v-icon>
            Fermer
          </v-btn>
        </v-card-actions>
      </template>
    </Modal>
  </div>
</template>

<script>
import { getProjectContexts } from '../../configs/forms';
import { EventBus } from '../../mixins';
import { requests } from '@/mixins/index';

import Modal from '@/components/Modal/Modal';

export default {
  name: 'ContextCard',
  components: { Modal },
  mixins: [requests],
  props: {
    content: {
      type: Object,
      default: null
    },
    addContextToUser: {
      type: Function,
      default: () => {}
    },
    removeIresaId: {
      type: Function,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    },
    contentAlteredValues: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      showCard: true,
      showContextModal: false,
      modalContext: null,
      loading: false,
      selectContext: null,
      dialogCreatAddContext: false,
      showConfirmDeleteContext: false
    };
  },
  computed: {
    alreadyHasSelectedContext () {
      return !!(this.content.iresa_ids.find(id => id.context === this.selectContext));
    },
    iresaIds () {
      const groups = {};
      const deactivatedPartners = this.$store.getters.getDeactivatedPartners || [];

      this.content.iresa_ids.forEach(id => {
        const context = this.content.contexts.find(c => c.value === id.context);
        if (!context) return;

        if (!groups.hasOwnProperty(context.value)) groups[context.value] = [];

        const extraInfo = id.extraContextInfo && id.extraContextInfo.type ? id.extraContextInfo.type : null;
        const isDeactivated = id.extraContextInfo && id.extraContextInfo.agencyKey ? deactivatedPartners.includes(id.extraContextInfo.agencyKey) : false;
        groups[context.value].push({
          label: `${id.iresa_id} | ${context.label} ${extraInfo ? ` - ${extraInfo}` : ''} `,
          iresaId: id.iresa_id,
          activeId: id.activeId,
          context: context.value,
          isDeactivated
        });
      });

      // EXCEPTION TO ALPHA CONTEXT
      const alphaContext = ['alpha', 'pegase'];

      alphaContext.forEach(ac => {
        const context = this.content.contexts.find(c => c.value === ac);

        if (context) {
          groups[ac] = [{
            label: context.label,
            context: context.value,
            activeId: true
          }];
        }
      });

      return groups;
    },
    contexts () {
      if (this.content.contexts) {
        return this.content.contexts;
      }
      return [];
    },
    allAvailableContexts () {
      const arr = [];
      getProjectContexts().map(obj => {
        if (['speedboat', 'labalaguere', 'partenaires'].includes(obj.value) || !this.contexts.find(e => e.value === obj.value)) {
          arr.push({ text: obj.text, value: obj.value });
        }
      });
      return arr;
    }
  },
  methods: {
    addIresaIdToContext () {
      EventBus.$emit('openPopupAddExistIresaCode', this.selectContext);
      this.closeDialogCreatAddContext();
    },
    closeDialogCreatAddContext () {
      this.dialogCreatAddContext = false;
    },
    createNewIresaId () {
      this.addContextToUser(this.selectContext);
      this.dialogCreatAddContext = false;
      this.selectContext = null;
    },
    removeIresaIdFromCustomer () {
      this.removeIresaId(this.modalContext.iresaId, this.modalContext.context);
    },
    getColor (value, activeId) {
      if (this.contentAlteredValues) {
        if (['speedboat', 'labalaguere'].includes(value) || value.startsWith('IRESA_')) {
          const iresaIdx = this.content.iresa_ids.findIndex(v => v.context === value);
          if (this.contentAlteredValues.iresa_ids && this.contentAlteredValues.iresa_ids[iresaIdx]) {
            return 'green';
          }
        }
        if (this.contentAlteredValues.horanet_id && value === 'alpha') {
          return 'green';
        }
      }

      if (['alpha', 'pegase'].includes(value)) {
        return 'red';
      }

      return activeId ? 'red' : '';
    },
    openDialog (context) {
      this.showContextModal = true;
      this.modalContext = context;
    },
    closeContextModal () {
      this.showContextModal = false;
    },
    openConfirmationDialog () {
      this.showContextModal = false;
      this.showConfirmDeleteContext = true;
    },
    closeConfirmDeleteContext () {
      this.showConfirmDeleteContext = false;
    },
    async setActiveCode () {
      if (modalContext.activeId || modalContext.isDeactivated) {
        return;
      }
      this.loading = true;
      this.closeContextModal();
      const responseCustomer = await this.setCustomerIresaContextActive(this.modalContext.context, this.modalContext.iresaId, this.content.uuid);
      const notification = { type: 'danger' };

      if (!responseCustomer.success) {
        notification.message = 'Erreur dans la définition du code iresa du client actif';
        EventBus.$emit('show-notifications', [notification]);
        return;
      }

      notification.message = 'Utilisateur actif iresa id update success';
      notification.type = 'success';
      EventBus.$emit('show-notifications', [notification]);
      EventBus.$emit('updateCustomerIresaIds', responseCustomer.data.iresa_ids);
      this.loading = false;
    },
    getContextLabel (context) {
      const iresaContext = (this.content.iresa_ids || []).find(i => i.context === context.value);
      if (!iresaContext) return context.label;

      const iresaExtraContextType = iresaContext.extraContextInfo ? iresaContext.extraContextInfo.type : null;
      const iresaExtraContextLabel = iresaExtraContextType ? ` - ${iresaExtraContextType}` : '';
      return context.label + iresaExtraContextLabel;
    },
    goContext () {
      if (['speedboat', 'labalaguere'].includes(this.modalContext.context) || this.modalContext.context.startsWith('IRESA_')) {
        if (this.$store.state.iResa.urlValid) {
          const iresa_context = this.content.iresa_ids.find(i => i.iresa_id === this.modalContext.iresaId);

          if (iresa_context.iresa_id) {
            const { urlValid } = this.$store.state.iResa;
            window.location.href = urlValid.replace('$CONT_ID$', iresa_context.iresa_id);
          }
        }
      }

      this.modalContext = null;
      this.showContextModal = false;
    },
    addContext (selected) {
      if (selected === 'partenaires') {
        const customerContext = [];
        if (this.content.iresa_ids) {
          this.content.iresa_ids.forEach(id => {
            if (!customerContext.includes(id.context)) customerContext.push(id.context);
          });
        }
        EventBus.$emit('showPartnerSearch', customerContext);
        this.$nextTick(() => {
          this.$refs.selectContext.reset();
        });
      } else if (['speedboat', 'labalaguere'].includes(selected)) {
        this.selectContext = selected;
        this.dialogCreatAddContext = true;
        this.$nextTick(() => {
          this.$refs.selectContext.reset();
        });
      } else if (selected) {
        this.addContextToUser(selected);
      }
    }
  }
};

</script>
<style scoped>
  .v-list {
    padding: 0;
  }
  .v-list-item {
    min-height: 0;
  }
  .deactivated-chip {
    opacity: 0.6;
    text-decoration: line-through;
  }
</style>
